module.exports = __webpack_public_path__ + "static/media/dmax-side-bar-1.43713d01.jpg";